// src/elements/Transition/constants.ts
var TRANSITION_CLASSNAME_MAP = {
  variant: {
    appear: {
      enter: "pd:transition-opacity pd:ease-out",
      enterFrom: "pd:opacity-0",
      enterTo: "pd:opacity-100",
      leave: "pd:transition-opacity pd:ease-in",
      leaveFrom: "pd:opacity-100",
      leaveTo: "pd:opacity-0"
    },
    "appear-from-top": {
      enter: "pd:transition pd:ease-out",
      enterFrom: "pd:opacity-0 pd:-translate-y-2",
      enterTo: "pd:opacity-100 pd:translate-y-0",
      leave: "pd:transition pd:ease-in",
      leaveFrom: "pd:opacity-100 pd:translate-y-0",
      leaveTo: "pd:opacity-0 pd:-translate-y-2"
    },
    "appear-from-bottom": {
      enter: "pd:transition pd:ease-out",
      enterFrom: "pd:opacity-0 pd:translate-y-2",
      enterTo: "pd:opacity-100 pd:translate-y-0",
      leave: "pd:transition pd:ease-in",
      leaveFrom: "pd:opacity-100 pd:translate-y-0",
      leaveTo: "pd:opacity-0 pd:translate-y-2"
    },
    "slide-from-left-full": {
      enter: "pd:transition pd:ease-out",
      enterFrom: "pd:-translate-x-full",
      enterTo: "pd:translate-x-0",
      leave: "pd:transition pd:ease-in",
      leaveFrom: "pd:translate-x-0",
      leaveTo: "pd:-translate-x-full"
    },
    "slide-from-right-full": {
      enter: "pd:transition pd:ease-out",
      enterFrom: "pd:translate-x-full",
      enterTo: "pd:translate-x-0",
      leave: "pd:transition pd:ease-in",
      leaveFrom: "pd:translate-x-0",
      leaveTo: "pd:translate-x-full"
    }
  },
  duration: {
    sm: {
      enter: "pd:duration-100",
      leave: "pd:duration-75"
    },
    md: {
      enter: "pd:duration-200",
      leave: "pd:duration-150"
    },
    lg: {
      enter: "pd:duration-400",
      leave: "pd:duration-300"
    }
  }
};
export { TRANSITION_CLASSNAME_MAP };